import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path = "transfer-lease-agreement";

export interface TranferInterface {
  page?: number;
  pageLimit?: number;
  search?: string;
}

interface CreateTransfer {
  branchId: number,
  transferDate: string,
  transferNo: string,
  leaseAgreementId: number,
  customerSentId: number,
  customerReceiveId: number,
  customerHeirId: number,
  status: string,
  transferLeaseAgreementApprove: {
    transferApproveDate: string,
    transferId: number,
    remark: string,
    employeeId: number,
    status: string
  }
}

interface ApproveTransfer {
  transferApproveDate: string,
  transferId: number,
  remark: string,
  employeeId: number,
  status: string,
  leaseAgreement: {
    leaseAgreementId: number,
    appointmentId: number,
    leaseAgreementNo: string,
    leaseAgreementDaft: string,
    branchId: number,
    leaseAgreementDate: string,
    leaseAgreementRemark: string,
    userId: number,
    prefixId: number,
    firstname: string,
    lastname: string,
    idCard: string,
    birthDay: string,
    mobilePhone: string,
    email: string,
    taxId: string,
    houseNumber: string,
    moo: string,
    village: string,
    soi: string,
    road: string,
    provinceId: number,
    districtId: number,
    subDistrictId: number,
    zipCode: string,
    leaseAgreementTypeId: number,
    leaseAgreementDateStart: string,
    leaseAgreementDateEnd: string,
    leasesTypeId: number,
    amount: number,
    status: string,
    createId: number,
    modifiedId: number,
    leaseAgreementApprove: {
      leaseAgreementApproveId: number,
      approveDate: string,
      leaseAgreementId: number,
      bidderId: number,
      remark: string,
      employeeId: number,
      status: string,
      createId: number,
      modifiedId: number
    }
  }
}


export type reviewTransferLeaseAgreementData = {
  status:string;
  remark: string | undefined;
}

export default class  TranferApi extends BaseAPI {
    static findAll(params:  TranferInterface): Promise<any> {
      return this.api.get(path, { params: { ...params } }).then((res) => res);
    }

    static findById(id:  number): Promise<any> {
      return this.api.get(`${path}/${id}`, )
    }

    static create(params:  CreateTransfer): Promise<any> {
      return this.api.post(path,  params );
    }

    static approve(params:  ApproveTransfer): Promise<any> {
      return this.api.post(`${path}/approve`,  params );
    }

    static updateStatus(params: any, id: number): Promise<any> {
      return this.api.post(`${path}/${id}/status`,  {status: params} );
    }


    
    // เรื่องอัพเดตสถาะนะ
    static review(transferId:number,body:reviewTransferLeaseAgreementData):Promise<AxiosResponse>{
      return this.api.patch(`${path}/${transferId}/update-status`,body)
    }
    static approved(transferId:number,body:reviewTransferLeaseAgreementData):Promise<AxiosResponse>{
      return this.api.patch(`${path}/${transferId}/update-status`,body)
    }
    static approveToAppointment(transferId:number,body:reviewTransferLeaseAgreementData):Promise<AxiosResponse>{
      return this.api.patch(`${path}/${transferId}/update-status`,body)
    }
    static logData(leaseAgreementId: number): Promise<AxiosResponse> {
            return this.api.get(`${path}/${leaseAgreementId}/log-data-transfer`)
    }
    static checkHasInvoice(transferId:number):Promise<AxiosResponse>{
      return this.api.get(`${path}/${transferId}/check-have-invoice`)
    }
  }

